import { connect } from 'react-redux';
import LoadingError from './LoadingError';

const mapStateToProps = state => ({
  rootLoaded: state.booking.rootLoaded
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingError);



// WEBPACK FOOTER //
// ./src/components/LoadingError/index.js